import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CardLike from './CardLike'; // Ensure this path is correct
import './VotingSection.css'; // Ensure this path is correct

// Helper function for ordinal numbers
const getOrdinal = (n) => {
  if (n === null || n === undefined) return '';
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const VotingSection = ({ cardInfo }) => {
  const [currentTime, setCurrentTime] = useState(Math.floor(Date.now() / 1000));
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [status, setStatus] = useState('loading'); // 'soon', 'active', 'ended', 'invalid'

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(Math.floor(Date.now() / 1000));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!cardInfo || !cardInfo.contest_data) {
      setStatus('invalid');
      return;
    }

    const { voting_start, voting_end } = cardInfo.contest_data;
    let targetTime = null;
    let newStatus = status;

    if (currentTime < voting_start) {
      newStatus = 'soon';
      targetTime = voting_start;
    } else if (currentTime < voting_end) {
      newStatus = 'active';
      targetTime = voting_end;
    } else {
      newStatus = 'ended';
    }
    // newStatus = 'active';
    if (newStatus !== status) {
      setStatus(newStatus);
    }

    if (targetTime && (newStatus === 'soon' || newStatus === 'active')) {
      const secondsRemaining = targetTime - currentTime;
      if (secondsRemaining > 0) {
        setTimeRemaining({
          days: Math.floor(secondsRemaining / 86400),
          hours: Math.floor((secondsRemaining % 86400) / 3600),
          minutes: Math.floor((secondsRemaining % 3600) / 60),
          seconds: secondsRemaining % 60,
        });
      } else {
        // Time ran out, recalculate status on next tick if not already changed
        setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        if (newStatus === 'soon' && currentTime >= voting_start) setStatus('active');
        else if (newStatus === 'active' && currentTime >= voting_end) setStatus('ended');
      }
    }
  }, [currentTime, cardInfo, status]);


  if (status === 'invalid' || !cardInfo.contest_data || Number(cardInfo.approvedGallery) !== 5) {
    return null;
  }

  const {
    contest_id,
    contest_name,
    contest_description,
    is_liked,
    place_received,
  } = cardInfo.contest_data;
  const imageUrl = `/images/contest/sketch/${contest_id}.svg`; // Make sure this path is correct

  // Compact Flip Digit (no labels, just numbers)
  const CompactFlipDigit = ({ value }) => (
    <div className="compact-flip-digit">
      <span>{value.toString().padStart(2, '0')}</span>
    </div>
  );

  const renderTimerOrAction = () => {
    switch (status) {
      case 'soon':
        return (
          <div className="timer-action-area">
            <div className="timer-label-compact">Voting Opens In</div>
            <div className="d-flex"> {/* This is the .timer-action-area > .d-flex */}
              {timeRemaining.days > 0 && (
                <>
                  <CompactFlipDigit value={timeRemaining.days} /> <span className="timer-sep">:</span>
                </>
              )}
              <CompactFlipDigit value={timeRemaining.hours} /> <span className="timer-sep">:</span>
              <CompactFlipDigit value={timeRemaining.minutes} /> <span className="timer-sep">:</span>
              <CompactFlipDigit value={timeRemaining.seconds} />
            </div>
          </div>
        );
      case 'active':
        return (
          <div className="timer-action-area">
      <CardLike
      cardid={cardInfo.cardId}
      initialLiked={is_liked}
      contestid={contest_id}
      compact={true}
    />
          </div>
        );
      case 'ended':
        if (place_received) {
          return (
            <div className="timer-action-area"> {/* Main area */}
              <div className="place-container"> {/* Wrapper for right-aligning place info */}
                <div className="place-display-compact">
                  <i className="bi bi-trophy-fill"></i> {getOrdinal(place_received)}
                </div>
                <div className="place-label-compact">Place</div>
              </div>
            </div>
          );
        }
        return (
          <div className="timer-action-area"> {/* Center the alert */}
            <div className="ended-text-compact alert alert-secondary">
              Contest Ended
            </div>
          </div>
        );
      default: // 'loading' or unforeseen
        return <div className="timer-action-area" style={{ minWidth: '120px' }}> </div>; // Placeholder
    }
  };

  return (
    <>
  {/* { status === 'active' && 
      <CardLike
      cardid={cardInfo.cardId}
      initialLiked={is_liked}
      contestid={contest_id}
      compact={true}
    />
  } */}
    <div className="contest-widget-uc mt-4 d-flex align-items-center p-2 bg-light border rounded shadow-sm my-2">
      {/* Left: Image */}
      <div className="contest-image-uc me-2">
      <Link to={`/gallery/contests/${contest_id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
        <img
          src={imageUrl}
          alt="" // Decorative, name provides context
          className="img-fluid rounded"
          onError={(e) => {
            e.target.style.display = 'none'; // Hide broken image
            if (e.target.parentElement) e.target.parentElement.style.display = 'none'; // Hide container
          }}
        />
      </Link>
      </div>
      {/* Center: Text Info */}
      <div className="contest-text-info-uc flex-grow-1 me-2">
      <Link to={`/gallery/contests/${contest_id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
        <h6 className="contest-name-uc mb-0 text-truncate">{contest_name || 'Contest'}</h6>
        {contest_description && (
          <p className="contest-desc-uc small text-muted mb-0">
            {contest_description}
          </p>
        )}
              </Link>
      </div>

      {/* Right: Timer/Action/Result */}
      <div className="contest-status-uc ms-auto">
        {renderTimerOrAction()}
      </div>
    </div>
    </>
  );
};

export default VotingSection;